import AuthHeading from "./AuthHeading";

const AuthDataFormSection = ({ title, children }) => {
  return (
    <div className="w-full bg-white border border-gray-300 rounded-lg shadow-lg p-10 space-y-6">
      <AuthHeading title={title} />
      {children}
    </div>
  );
};

export default AuthDataFormSection;
